export const Config = {
  site_name: '세금포인트 할인쇼핑몰',
  title: '세금포인트 할인쇼핑몰',
  description:
    '납세자가 보유하고 있는 세금포인트를 사용하여 중소기업 제품을 할인받아 구매할 수 있는 세금포인트 할인쇼핑몰',
  locale: 'ko',
};
